import { useState } from "react";
import DiscountForm from "./DiscountForm";
import AdsForm from "./AdsForm";
export default function PromotionsPage() {
  const [activeTab, setActiveTab] = useState("discount");

  return (
    <div className="p-4">
      {/* Header */}
      <h4 className="fw-semibold mb-4"> Promotions & Ads</h4>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "discount" ? "active" : ""}`}
            onClick={() => setActiveTab("discount")}
          >
            Discounts
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "ads" ? "active" : ""}`}
            onClick={() => setActiveTab("ads")}
          >
            Ads
          </button>
        </li>
      </ul>
      <h3>Under production!</h3>

      {/* {activeTab === "discount" && <DiscountForm />} */}
      {/* {activeTab === "ads" && <AdsForm />} */}
    </div>
  );
}
